import React, { Dispatch, SetStateAction } from 'react';
import BSPagination from 'react-bootstrap/Pagination';
import { usePagination, DOTS } from '@/components/Pagination/hooks/usePagination';
import { IBlogListRequest } from '../blogService';
import styles from './BlogPagination.module.scss';

export interface IPagination {
  pageCount?: number;
  currentPage?: number;
  setRequest: Dispatch<SetStateAction<IBlogListRequest>>;
  getUrl: (i: number) => string;
  boundaries?: number;
  siblings?: number;
}

export const Pagination = ({ pageCount = 0, currentPage = 1, setRequest, getUrl }: IPagination) => {
  const pagination = usePagination({
    page: currentPage,
    total: pageCount
  });

  const setCurrentPage = (newPage: number) => {
    setRequest((prevRequest) => {
      return {
        ...prevRequest,
        page: newPage
      };
    });

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className={styles.paginationContainer}>
      {pageCount !== 0 && (
        <BSPagination>
          <BSPagination.Prev
            href={getUrl(currentPage - 1)}
            onClick={(e) => {
              e.preventDefault();
              setCurrentPage(currentPage - 1);
            }}
            rel="prev"
            disabled={currentPage === 1}
          />
          {pagination.range.map((page, idx) => {
            if (page === DOTS) {
              return <BSPagination.Ellipsis key={idx} disabled />;
            }
            return (
              <BSPagination.Item
                key={idx}
                active={page === currentPage}
                href={getUrl(page)}
                onClick={(e) => {
                  e.preventDefault();
                  setCurrentPage(page);
                }}
              >
                {page}
              </BSPagination.Item>
            );
          })}
          <BSPagination.Next
            href={getUrl(currentPage + 1)}
            onClick={(e) => {
              e.preventDefault();
              setCurrentPage(currentPage + 1);
            }}
            rel="next"
            disabled={currentPage === pageCount}
          />
        </BSPagination>
      )}
    </div>
  );
};
